import React from 'react';
import ClearPaneComponent from '../../reusable/ClearPaneComponent';
import MapComponent from '../../reusable/MapComponent';
import BrowsemodePaneComponent from '../BrowsemodePaneComponent/BrowsemodePaneComponent';
import WebPageComponent from "../../reusable/WebPageComponent";

interface Props {
  pane: number,
  cam: any
}

const BrowsemodeMainPaneComponent: React.FC<Props> = ({pane, cam}) => {
  // TODO
  // Create wrapper BrowsemodePaneWrapperComponent
  // to decide what entity to show (camera, map, webpage)

  return (
    <div className='pos-rel w-100 h-100 o-hidden' id={`pane-${pane}`}>
      <ClearPaneComponent pane={pane}/>
      {
        cam?.type === 'Map'
          ? <MapComponent pane={pane} mapId={cam?.id}/>
          : cam?.type === 'WebPage'
            ? <WebPageComponent webPageId={cam?.id}/>
            : <BrowsemodePaneComponent pane={pane}/>
      }
    </div>
  )
};


export default BrowsemodeMainPaneComponent;